import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgShape = (props, ref) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 36 36", width: 24, height: 24, ref: ref, ...props, children: _jsx("circle", { cx: 18, cy: 18, r: 18, fill: "currentColor" }) }));
const ForwardRef = forwardRef(SvgShape);
export default ForwardRef;
